export function isFileSizeLargerThan(file: File, maxSize: number) {
  return file.size > maxSize
}

export const isFileOverLimit = (file: File) =>
  isFileSizeLargerThan(file, 1024 * 1024 * 1024 /** 1GB */)
